module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-blurbs element-with-heading",
    attrs: {
      "id": "blurbs"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "blurbs-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise for Joanna Stephen -Ward")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "blurbs-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("I really enjoyed this book,had me gripped from beginning to end. A must read, I didn't want this book to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v("Karen S – Amazon Reviewer")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-193"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out-copy.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('i', [_vm._v("Best book I have read in a long time.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("This author is fantastic. I couldn't wait to see what happened next. What a brilliant ending too. I can't praise this book enough. Loved all the characters.....except Gloria of course ... but I did feel sorry for her too. What a good book. 5 stars for sure xx")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v("Kylee – Amazon Reviewer")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-193"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out-copy.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('i', [_vm._v("Great read, couldn’t put it down. Character depth was brilliant and the story built nicely to a unexpected ending. Will look for more by this Author.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v("Amazon Customer")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-193"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out-copy.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('i', [_vm._v("The Doll Collector exceeded all my expectations. It's different, it has some dry humour in it and I couldn't put it down. I read about 85% of it in one sitting. I loved it.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v("Nicola in South Yorkshire – Amazon Top 1000 Reviewer")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-193"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out-copy.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f5d66ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise-for-joanna-stephen--ward.vue
// module id = 72
// module chunks = 0